var React = require('react');

function SaleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#f10f60","d":"M9.5 7c.83 0 1.5.67 1.5 1.5S10.33 10 9.5 10 8 9.33 8 8.5 8.67 7 9.5 7m5 7c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5m-6.09 3L7 15.59 15.59 7 17 8.41 8.41 17M18.65 2.85l.61 3.86 3.51 1.79L21 12l1.78 3.5-3.54 1.79-.61 3.86-3.89-.61-2.77 2.77-2.78-2.81-3.86.64-.62-3.89-3.49-1.78L3 11.97 1.23 8.5l3.51-1.81.61-3.82 3.87.63L12 .695l2.76 2.765 3.89-.61m1.45 6.52L17.5 8 17 5.11l-2.9.42L12 3.5 9.9 5.53 7 5.11 6.5 8 3.9 9.37 5.2 12l-1.3 2.63L6.5 16l.5 2.89 2.9-.42L12 20.5l2.1-2.03 2.9.42.5-2.89 2.6-1.37L18.8 12l1.3-2.63Z"}));
}

SaleInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = SaleInline;

SaleInline.default = SaleInline;
